import {
    //Dialog,
    // DialogTitle,
    DialogActions,
    //DialogContent,
    MenuItem,
    FormControl,
    Grid,
    Divider,
    Radio,
    RadioGroup,
    FormControlLabel,
    TextField,
    Avatar,
    ListItemAvatar,
    Stack,
    Drawer

} from '@mui/material';

//import BadgeStatus from '../../../BadgeStatus';
import { LoadingButton } from '@mui/lab';
import HeaderModal from 'src/components/modal/HeaderModal';
import { SelectZui } from 'src/components/zui';
import { SelectItem } from 'src/@/components/ui/select';
import { Checkbox } from 'src/@/components/ui/checkbox';
import { useEffect, useState } from 'react';
import { Switch } from 'src/@/components/ui/switch';
import { Button } from "src/@/components/ui/button"
import { Input } from "src/@/components/ui/input"
import { Label } from "src/@/components/ui/label"
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "src/@/components/ui/popover"
import Iconify from 'src/components/Iconify';
import getActionListaUsuariosByClienteId from 'src/actions/usuarios/getActionListaUsuariosByClienteId';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { useSnackbar } from 'notistack';
import v2_actionEditarLead from 'src/actions/v2/crm/v2_actionEditarLead';
import { RowInput } from 'src/components/forms/RowInput';
import { OptionsSelect } from 'src/@/components/shared';

// ----------------------------------------------------------------------

export default function DrawerConvertLead({ user, lead, onCallback, configCrm }) {
    const [lista, setLista] = useState([]);
    const [isSendMessages, setIsSendMessages] = useState(true);
    const [selectedReason, setSelectedReason] = useState(null);
    const [loading, setLoading] = useState(false);
    const [option, setOption] = useState(1);
    const { enqueueSnackbar } = useSnackbar();



    async function buscarUsuarios() {
        try {
            const response = await getActionListaUsuariosByClienteId(user.clienteId);
            setLista(response.data.usuarios);
        } catch (error) {
            console.log('error', error)
        }
    }

    async function editarLead() {

        try {
            let data = {
                action: "editar_conversao",
                scope: {
                    motivo_perda: selectedReason,
                    convertido: option,
                    data_conversao: new Date()
                }
            }
            setLoading(true);
            await v2_actionEditarLead(lead._id, data, user.id);
            onCallback();
            setLoading(false)
            enqueueSnackbar('Usuário alterado com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        } catch (error) {
            console.log('error', error)
            enqueueSnackbar('Erro ao transferir usuário', { variant: 'error', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        }
    }

    useEffect(() => {
        buscarUsuarios();
        return () => {
            setLista([]);
            setSelectedReason(null);
        }
    }, []);

    let newReasons = configCrm?.motivos?.map((item) => {
        return {
            value: item._id,
            label: item.name
        }
    })


    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button className="flex justify-center h-8" variant="outline">
                    <Iconify icon="material-symbols:social-leaderboard" className="mr-2" />
                    Marcar
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-80 z-[9999]">
                <div className='w-2/3'>
                    <OptionsSelect
                        title="Marcar como"
                        options={[
                            { value: 1, label: 'Venda', color: 'bg-green-500' },
                            { value: 2, label: 'Perda', color: 'bg-red-500' },
                        ]}
                        value={option}
                        changeValue={(e) => {
                            setOption(e);
                        }}
                    />
                </div>

                {option === 2 && (
                    <div className="flex flex-col gap-2 mt-4">
                        <RowInput
                            label={'motivo da perda'}
                            input={
                                <SelectZui
                                    value={selectedReason}
                                    list={newReasons}
                                    fullWidth
                                    onChange={event => {
                                        setSelectedReason(event);
                                        console.log('event selectedReason', event)
                                    }}
                                    itemSelect={(item) => (
                                        <SelectItem key={item.value} value={item.value}>
                                            {item.label}
                                        </SelectItem>
                                    )}
                                />
                            }
                        />

                    </div>
                )}

                <Divider className='my-4 border-dashed' />

                <ButtonLoading
                    loading={loading}
                    onClick={editarLead}
                    disabled={!option || (option === 2 && !selectedReason)}
                    className={`${!option || (option === 2 && !selectedReason) ? 'bg-slate-400' : 'bg-slate-700'} w-full `}
                >
                    {loading ? 'Salvando...' : `${!option || (option === 2 && !selectedReason) ? 'Selecione um motivo' : 'Salvar'}`}
                </ButtonLoading>

            </PopoverContent>
        </Popover>
    )

}
